import { Component } from '@angular/core';
import { BaseFilterComponent } from '../base-filter/base-filter.component';

@Component({
    selector: 'app-simple-filter',
    templateUrl: './simple-filter.component.html',
    styleUrls: ['./simple-filter.component.scss'],
    standalone: false
})
export class SimpleFilterComponent extends BaseFilterComponent {}
